function hasClass(el, ...clasNames) {
  const classList = el.classList;
  return clasNames.every(token => classList.contains(token));
}

window.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector(`nav[aria-label="Table of Contents"]`);
  if (!nav) return;

  // Adjusts top position for sticky nav.
  let offsetTop = 0;
  if (nav.classList.contains("sticky")) {
    const parentElement = nav.parentElement;
    offsetTop = parentElement.offsetTop;
    nav.style.top = `${ offsetTop }px`;
  }

  // Rearrange TOC to match order of anchors on page.
  const toc = nav.querySelector(`:scope > ul`);
  const items = Array.from(toc.children);
  // Use link's href as selector for actual anchor elements, which are sorted by appearance.
  const selectors = items.map(li => li.querySelector("a").getAttribute("href"));
  const anchors = document.querySelectorAll(selectors.join(","));
  // Re-append the items by the order of anchor elements.
  Array.from(anchors).forEach(anchor => {
    const link = toc.querySelector(`a[href="#${anchor.id}"]`);
    toc.appendChild(link.parentElement);
  });

  // Scrollspy.
  // const anchors = document.querySelectorAll("a[id]");
  const observer = new IntersectionObserver(entries => {
    // Only finds the first entry that intersects.
    const entry = entries.find(entry => {
      return entry.intersectionRatio > 0;
    });
    if (!entry) return;

    // Clears out active state for all TOC items.
    items.forEach((li) => {
      li.classList.remove("active");
      li.querySelector("a").removeAttribute("aria-current");
    });

    // Set active state to TOC item matching intersecting entry.
    const id = entry.target.getAttribute("id");
    const anchor = nav.querySelector(`li a[href="#${id}"]`);
    anchor.parentElement.classList.add("active");
    anchor.setAttribute("aria-current", "true");
  }, {
    rootMargin: `0px 0% -75% 0%`,
  });

  // Track all anchors that have an `id` applied
  anchors.forEach((anchor) => {
    observer.observe(anchor);
  });

});
